// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2Au6O","log":"ModalInventoryLogs_log__2RLaC","date":"ModalInventoryLogs_date__vh5gj","userName":"ModalInventoryLogs_userName__1xhkk"};